import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=190edb67"
import script from "./paginate.vue?vue&type=script&lang=js"
export * from "./paginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports